import React, { forwardRef } from 'react'

import Header from '../../../components/header'

import userGreen from '../../../assets/svg/userGreen.svg'

import * as S from './styles'

import IProps from './props'

const EditProfileImage = forwardRef<HTMLInputElement, IProps>((props, ref) => (
  <S.Container>
    <Header title="Editar foto de perfil" />
    <S.Content>
      <S.RoundedImage
        src={props.imgUrl ? props.imgUrl : userGreen}
        alt="Foto de perfil"
      />
      <S.WarningText>Extensões de arquivos aceitas: JPEG e JPG</S.WarningText>
      <S.WarningText>Tamanho máximo suportado: 10MB</S.WarningText>
      <S.ButtonsContainer>
        <S.Button onClick={props.handleFileInput}>Escolher arquivo</S.Button>
        <S.Button onClick={props.handleSave}>Salvar</S.Button>
        <input
          type="file"
          accept="image/*"
          onChange={props.handleImageSelect}
          ref={ref}
          style={{
            display: 'none',
          }}
        />
      </S.ButtonsContainer>
    </S.Content>
  </S.Container>
))

export default EditProfileImage
